var CheckoutButton = {
	/**
	 * Init.
	 */
	init: function () {
		CheckoutButton.prepare_button_dom();
		jQuery( document ).on( 'click', '#place_order', CheckoutButton.on_button_click );
		jQuery( document.body ).on( 'checkout_error', CheckoutButton.on_error );
		jQuery( document.body ).on( 'updated_checkout', CheckoutButton.on_updated_checkout );
	},

	/**
	 * Prepare button DOM for animation.
	 * @returns 
	 */
	prepare_button_dom: function () {
		if ( jQuery( "#place_order" ).find( '.flux-submit-dots' ).length ) {
			return;
		}

		jQuery( "#place_order" ).html( jQuery( "#place_order" ).html() + `<span class='flux-submit-dots'>
			<i class='flux-submit-dot flux-submit-dot__1'></i>
			<i class='flux-submit-dot flux-submit-dot__2'></i>
			<i class='flux-submit-dot flux-submit-dot__3'></i>
		</span>` );
	},

	/**
	 * On button click.
	 */
	on_button_click: function () {
		CheckoutButton.prepare_button_dom();
		jQuery( "#place_order" ).addClass( 'flux-checkout-btn-loading' );
	},

	/**
	 * On WooCommerce error.
	 */
	on_error: function () {
		jQuery( "#place_order" ).removeClass( 'flux-checkout-btn-loading' );
	},

	/**
	 * On updated_checkout event. Modify the button html.
	 *
	 * @param {event} e
	 * @param {data} data
	 */
	on_updated_checkout: function ( e, data ) {
		if ( ! data || ! data.fragments || ! data.fragments.flux ) {
			return;
		}

		if ( data.fragments.flux.total ) {
			jQuery( '#place_order' ).html( `${flux_checkout_vars.i18n.pay} ${data.fragments.flux.total}` );
		}

	}
};

export default CheckoutButton;